/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-30 11:39:04
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Icon } from '@shopify/polaris';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';

type Props = {
  heading: string,
  isAsc: boolean,
  idSort: string,
  id: string,
  onSort: () => void
};
// DONE
class TableHeadingCell extends Component<Props> {
  render() {
    const { heading, id, isAsc, onSort, idSort } = this.props;
    const defaultSort = _.includes(['searchTerm', 'filterOptions'], idSort) ? true : false;

    return (
      <span
        className="sortable-heading"
        onClick={() => onSort(id, id === idSort ? !isAsc : defaultSort)}>
        <span>{heading}</span>
        {idSort === id ? (
          <span className="sort-icon">
            {isAsc ? <Icon source={CaretDownMinor} /> : <Icon source={CaretUpMinor} />}
          </span>
        ) : (
          ''
        )}
      </span>
    );
  }
}

export default TableHeadingCell;
